import { Box, useMediaQuery } from "@mui/material";
import { observer } from "mobx-react-lite";
import McpServerFaqSection from "../../components/Home/McpServer/McpServerFaqSection/McpServerFaqSection";
import McpServerHeaderSection from "../../components/Home/McpServer/McpServerHeaderSection/McpServerHeaderSection";
import McpServerInstallSection from "../../components/Home/McpServer/McpServerInstallSection/McpServerInstallSection.tsx";
import styles from "./McpServerTab.module.scss";

const McpServerTab = () => {
	const isBigScreen = useMediaQuery("(min-width:2460px)");
	return (
		<Box className={styles.container}>
			<Box className={styles.mcpInstructionsContainer}>
				<McpServerHeaderSection />
				{!isBigScreen && <McpServerInstallSection />}
			</Box>
			<McpServerFaqSection />
		</Box>
	);
};

export default observer(McpServerTab);
